import React from 'react';
import {
  MDBFooter,
  MDBContainer,
  MDBCol,
  MDBRow,
  MDBInput
} from 'mdb-react-ui-kit';

export default function Footer() {
  return (
    <MDBFooter  className='footer text-center text-white text-lg-left pt-5' style={{ backgroundImage: "url('img/india-travel.png')" }}>
      <MDBContainer className='p-4 pb-0'>
        <MDBRow className='align-items-center'>
        <div className='col-md-6 footer-title'>
          <h3>To Know More Get In Touch With Our Travel Consultant !</h3>
          <p>We’re here to listen, assist, and make a difference. Our dedicated team is ready to respond to your needs, whether you have questions, feedback, or require support.</p>
          <p>Feel free to reach out to us and experience personalized attention and exceptional service.</p>
          <p>Together, we’ll create a seamless and rewarding experience tailored just for you.</p>

          <div className="btn-container my-3"><button className="enquiry-btn px-3"><a data-test="nav-link" className="nav-link header-content" aria-current="page" href="tel:+919419046560" ><i className="fa-solid fa-phone rounded-circle"></i>+919419046560</a></button></div>

          {/* <div className='py-4 img-footer'>
            <div className='left-footer'>
              <img className='one-left' src='img/travelers-choise.webp' alt=''/>
              <img className='two-left' src='img/Incredible_India.webp' alt=''/>
            </div>
            <div className='right-footer'>
              <img className='one-left' src='img/Jammu-and-Kashmir.webp' alt=''/>
              <p>Registered with J&K Tourism</p>
              <p>Regd No. : JKEA00000988</p>
            </div>
          </div> */}
        </div>
        
        <div className='col-md-6'>
          <div className='footer-logo'>
            <img src='img/icons8-visa-card-48.png'/>
            <img src='img/icons8-google-pay-india-48.png'/>
            <img src='img/icons8-bhim-upi-50.png'/>
          </div>
           <div className='footer-logo'>
            <img src='img/icons8-mastercard-16.png'/>
            <img src='img/icons8-paytm-48.png'/>
            <img src='img/icons8-phone-pe-48.png'/>
          </div>
        </div>
        </MDBRow>
      </MDBContainer>

      <div className='copyright text-center p-3' style={{ backgroundColor: 'rgba(0, 0, 0, 0.2)' }}>
        &copy; {new Date().getFullYear()} Copyright: © 2025{' '}
        <a className='text-white' href='#'>
         rizztourandtravels.com. All rights reserved.
        </a>
      </div>
    </MDBFooter>
  );
}